/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return TagPostureBase.fixupPrototype; }

    static newInstance(model: Partial<TagPostureBase>): TagPostureBase {
        let obj = Object.assign(new TagPostureBase(), model);
        TagPostureBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureBase>): TagPostureBase {
        if (!model) return null;
        return TagPostureBase.newInstance(<TagPostureBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureBase) {
        if (!obj) return;

        models.TagPostureBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureBase): boolean {
        switch (obj.__type)
        {
            case "TagPostureCloudAccountSummary":
                Object.setPrototypeOf(obj, models.TagPostureCloudAccountSummary.prototype);
                break;
            case "TagPostureResource":
                Object.setPrototypeOf(obj, models.TagPostureResource.prototype);
                break;
            case "TagPostureResourceBase":
                Object.setPrototypeOf(obj, models.TagPostureResourceBase.prototype);
                break;
            case "TagPostureResourceSummary":
                Object.setPrototypeOf(obj, models.TagPostureResourceSummary.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof TagPostureBase)[] {
        return [
            models.TagPostureCloudAccountSummary,
            models.TagPostureResource,
            models.TagPostureResourceBase,
            models.TagPostureResourceSummary,
        ];
    }

    fixupFields() {
    }

    /**
     * Id of the CoreStack Account under which this tenant resides
     */
    account_id: string;

    /**
     * Id of the CoreStack Tenant for the posture
     */
    tenant_id: string;

    /**
     * Cloud Provider being summarized
     */
    cloud: models.CloudServiceName;

    /**
     * Cloud Account id for the posture
     */
    cloud_account_id: string;

}
